import { Fragment, ReactNode } from "react";
import { UseFormRegister } from "react-hook-form";

import { PART_TAG_FIELD_GROUPS, PartTagFormValues } from "../../utils/partTagFields";

interface PartTagFieldGroupsProps {
  register: UseFormRegister<PartTagFormValues>;
  // Rendered between the Header group and the rest, where the line sits on the label.
  afterHeader?: ReactNode;
}

export default function PartTagFieldGroups({ register, afterHeader }: PartTagFieldGroupsProps) {
  return (
    <div className="space-y-4">
      {PART_TAG_FIELD_GROUPS.map((group, index) => (
        <Fragment key={group.title}>
        {index === 1 && afterHeader}
        <div className="rounded-md border border-gray-200 bg-white p-3">
          <h2 className="text-sm font-semibold text-gray-900">{group.title}</h2>
          <p className="text-xs text-gray-500 mt-0.5">{group.description}</p>

          <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2">
            {group.fields.map((f) => (
              <label key={f.path} className="flex items-start gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  {...register(`display.${f.path}`)}
                  className="mt-0.5 h-4 w-4 shrink-0 rounded border-gray-300 text-primary-600 focus:ring-primary-500"
                />
                <span className="min-w-0">
                  <span className="block text-sm font-medium text-gray-700">{f.label}</span>
                  {f.hint && <span className="block text-xs text-gray-500">{f.hint}</span>}
                </span>
              </label>
            ))}
          </div>
        </div>
        </Fragment>
      ))}
    </div>
  );
}
